import { render, staticRenderFns } from "./marquee-headline.vue?vue&type=template&id=04b38909&scoped=true&lang=pug"
import script from "./marquee-headline.vue?vue&type=script&lang=coffee"
export * from "./marquee-headline.vue?vue&type=script&lang=coffee"
import style0 from "./marquee-headline.vue?vue&type=style&index=0&id=04b38909&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b38909",
  null
  
)

export default component.exports